"use strict";
exports.__esModule = true;
exports.LambdaStatusCode = void 0;
var LambdaStatusCode;
(function (LambdaStatusCode) {
    LambdaStatusCode[LambdaStatusCode["Successful"] = 200] = "Successful";
    LambdaStatusCode[LambdaStatusCode["BadRequest"] = 400] = "BadRequest";
    LambdaStatusCode[LambdaStatusCode["NotFound"] = 404] = "NotFound";
    LambdaStatusCode[LambdaStatusCode["MethodNotAllowed"] = 405] = "MethodNotAllowed";
    LambdaStatusCode[LambdaStatusCode["InternalError"] = 500] = "InternalError";
})(LambdaStatusCode = exports.LambdaStatusCode || (exports.LambdaStatusCode = {}));
